// extracted by mini-css-extract-plugin
module.exports = {"container":"Ve","list":"We"};